module.exports = __webpack_public_path__ + "static/media/plain.855df3fb.jpg";